import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import startCase from 'lodash-es/startCase';

import { ShadowBox, LinkText } from '@components/common';
import TableAccessaryLabel from '@components/TableAccessaryLabel';
import TableCell from '@components/TableCell';
import { stripePriceConverter } from '@services/transform';

import { BillingHistorySelectors } from '@redux/BillingHistoryRedux';

import { COUPON_TYPES } from '@services/minte';

const CleanButton = styled(TableAccessaryLabel)`
  width: 102px;
  max-width: 102px;
`;

function BillingHistoryDetail(props) {
  const { billingList } = props;

  if (!billingList) {
    return null;
  }

  const renderHistoryItem = (historyItem, index) => {
    const {
      cost: receiptDetails,
      defaultFormattedDate,
      additionalService,
      serviceType,
      transactions
    } = historyItem;

    const {
      formattedTransactionDate,
      price: total,
      status: transactionStatus
    } = transactions;

    const {
      beforeDiscountCost,
      couponDetails,
      discountDetails: recurringDiscount
    } = receiptDetails || {};

    const { title, icon } = serviceType;
    const addonIcons =
      additionalService && additionalService.length > 0
        ? additionalService.map(({ icon }) => icon)
        : undefined;
    const addonIconTooltips =
      additionalService && additionalService.length > 0
        ? additionalService.reduce(
            (acc, { icon, title }) => ({ ...acc, [icon]: title }),
            {}
          )
        : undefined;

    const addonText = addonIcons ? undefined : 'None';

    const {
      off: couponOff,
      valueOff: couponValue,
      type: couponType,
      coupon: couponName
    } = couponDetails || {};
    const { off: recurringDiscountValue, type: recurringDiscountType } =
      recurringDiscount || {};

    return (
      <ShadowBox mb={4} key={index}>
        <TableCell
          title="Type"
          renderAccessories={() => (
            <CleanButton
              p={1}
              flexDirection="row"
              justifyContent="space-between"
              title={title}
              tooltip={title}
              icon={icon}
              size="small"
              onClick={() => {}}
            />
          )}
        />
        <TableCell
          title="Additional Services"
          rightIcons={addonIcons}
          iconTooltips={addonIconTooltips}
          rightIconColor="gold"
          rightText={addonText}
        />

        <TableCell
          title="Original Price"
          rightText={`$${stripePriceConverter(beforeDiscountCost)}`}
        />

        {!isNaN(couponValue) && (
          <TableCell
            title="Discount"
            rightText={`${
              couponType === COUPON_TYPES.FIXED_AMOUNTINGLE
                ? `$${stripePriceConverter(couponValue)}`
                : `${couponOff}%`
            }(${couponName})`}
          />
        )}

        {!isNaN(recurringDiscountValue) && (
          <TableCell
            title="Package discount"
            rightText={
              recurringDiscountType === COUPON_TYPES.FIXED_AMOUNTINGLE
                ? `$${stripePriceConverter(recurringDiscountValue)}`
                : `${recurringDiscountValue}%`
            }
          />
        )}

        <TableCell title="Final Cost" rightText={`$${total}`} />
        <TableCell title="Service date" rightText={defaultFormattedDate} />
        <TableCell
          title="Payment date"
          rightText={`${formattedTransactionDate}`}
        />
        <TableCell title="Status" rightText={startCase(transactionStatus)} />
        <LinkText p={2} textAlign="center" disabled>
          Download receipt
        </LinkText>
      </ShadowBox>
    );
  };

  return billingList.map(renderHistoryItem);
}

BillingHistoryDetail.propTypes = {
  billingList: PropTypes.array
};

const mapStatesToProps = state => ({
  billingList: BillingHistorySelectors.selectBillingHistory(state)
});

export default connect(mapStatesToProps)(BillingHistoryDetail);
